module.exports = __webpack_public_path__ + "media/images/web_suite/icon_mobile-4323e3c49ed855805a916eb29f7a7ba2.png";